import { CarouselMulti } from './CarouselMulti/CarouselMulti';
import { CarouselDefault } from './CarouselDefault/CarouselDefault';

export const CarouselLayouts = {
  Default: CarouselDefault,
  Multi: CarouselMulti,
};
